var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaitingWhole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 214.98 214.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0a4a7c;}.cls-2,.cls-3{opacity:0.2;}.cls-3,.cls-4{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215,107.46A107.49,107.49,0,1,0,107.46,215,107.52,107.52,0,0,0,215,107.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107.46,199A107.48,107.48,0,0,1,.3,99.46q-.3,4-.3,8a107.49,107.49,0,1,0,215,0q0-4-.3-8A107.54,107.54,0,0,1,107.46,199Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M107.46,16a107.53,107.53,0,0,1,107.22,99.46q.3-4,.3-8a107.49,107.49,0,0,0-215,0q0,4,.3,8A107.47,107.47,0,0,1,107.46,16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M178.88,107.49A71.48,71.48,0,0,0,107.49,36.1h0A71.47,71.47,0,0,0,36.1,107.49h0a71.39,71.39,0,0,0,142.78,0Zm-71.39,61.33a61.39,61.39,0,0,1-61.32-61.33h0a61.39,61.39,0,0,1,61.32-61.32,5,5,0,0,1-3-1,5,5,0,0,0,3,1,61.39,61.39,0,0,1,61.32,61.32h0A61.39,61.39,0,0,1,107.49,168.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M127.37,89.2l-20.11,20.11L80.51,82.55a5,5,0,0,0-7.12,7.12L103.7,120h0a5.75,5.75,0,0,0,.67.55l.12.1a5.34,5.34,0,0,0,.82.43l.06,0a5.07,5.07,0,0,0,.76.22l.17,0a4.07,4.07,0,0,0,.59.06c.13,0,.25,0,.37,0a5,5,0,0,0,3.56-1.48l23.67-23.66a5,5,0,1,0-7.12-7.12Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingWhole);
export default __webpack_public_path__ + "static/media/Waiting_Whole.f6d8c5fb0b5a1496e574a0b0c8f027a4.svg";
export { ForwardRef as ReactComponent };